module.exports = __webpack_public_path__ + "img/hint-three-eng.a0451658.jpg";